// js
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { VictoryPie } from 'victory';
import FormattedGB from '../common/FormattedGB';
import DataSourcesPieChartLegend from './DataSourcesPieChartLegend';
// css
import '../../styles/components/analytics/DataSourcesPieChart.scss';


const DataSourcesPieChart = ({ title, active, data, labelFontSize, legendPos, colors, nonCiscoDataPerDay, ciscoDataPerDay }) => {

  const isDataItemActive = item => item.value > 0 && item.active;
  const activeData = data.filter(isDataItemActive);
  const activeColorIndexes = data
    .map((item, index) => isDataItemActive(item) ? index : null)
    .filter(item => item !== null);
  const activeColors = colors
    .map((color, index) => activeColorIndexes.includes(index) ? color : null)
    .filter(color => color !== null);
  const total = activeData.reduce((acc, item) => acc + item.value, 0);
  const isEmptyChart = total === 0;
  const emptyChartColors = ['#000000'];
  const chartData =
    isEmptyChart ?
    (
      [
        {
          x: ' ',
          label: '',
          y: 100
        }
      ]
    ) :
    (
      activeData
        .map((item) => (
          {
            x: `${Math.round(item.value / total * 100)}%`,
            y: Math.round(item.value * 100)
          }
        ))
    );
  const classNames = classnames({
    'analytics__data-sources-pie-chart': true,
    'analytics__data-sources-pie-chart--empty': isEmptyChart,
    'analytics__data-sources-pie-chart--inactive': !active
  });
  const colW = legendPos === 'bottom' ? [12, 0, 12] : [5, 1, 6];

  return (
    <div className={classNames}>
      <div className='row'>
        <div className={`col-md-${colW[0]}`}>
          <div className='analytics__data-sources-pie-chart__chart'>
            <VictoryPie
              data={chartData}
              colorScale={activeColors.length ? activeColors : emptyChartColors}
              innerRadius={120}
              padding={{
                top: 0,
                left: 0,
                right: 0,
                bottom: 0
              }}
              style={{
                data: {
                  fillOpacity: isEmptyChart ? 0.05 : 1
                },
                labels: {
                  display: 'none'
                }
              }}
            />
            <div
              className='analytics__data-sources-pie-chart__chart-label'
              style={{ fontSize: labelFontSize / 2}}
            >
              <FormattedGB
                value={total}
                perDay
                labelStyle={{ fontSize: labelFontSize / 2}}
                valueStyle={{ fontSize: labelFontSize }}
              />
            </div>
          </div>
        </div>
        <div className={`col-md-${colW[1]}`} />
        <div className={`col-md-${colW[2]}`}>
          {title &&
            <h3>{title}</h3>
          }
          {title && nonCiscoDataPerDay !== undefined && ciscoDataPerDay !== undefined &&
            <div className='analytics__data-sources-pie-chart__cisco-split'>
              <div>
                <FormattedGB value={nonCiscoDataPerDay} perDay /> Non Cisco
              </div>
              <div>
                <FormattedGB value={ciscoDataPerDay} perDay /> Cisco Data
              </div>
            </div>
          }
          <DataSourcesPieChartLegend
            data={data}
            colors={colors}
          />
        </div>
      </div>
    </div>
  );
};

DataSourcesPieChart.defaultProps = {
  labelFontSize: 24,
  active: true,
  legendPos: 'right',
  nonCiscoDataPerDay: undefined,
  ciscoDataPerDay: undefined
};

DataSourcesPieChart.propTypes = {
  title: PropTypes.string,
  active: PropTypes.bool,
  data: PropTypes.array.isRequired,
  labelFontSize: PropTypes.number,
  legendPos: PropTypes.string,
  colors: PropTypes.array.isRequired,
  nonCiscoDataPerDay: PropTypes.number,
  ciscoDataPerDay: PropTypes.number
};

export default DataSourcesPieChart;



// WEBPACK FOOTER //
// ./src/components/analytics/DataSourcesPieChart.js